import styled from 'styled-components';
import { spacing, colors, body2 } from 'ui/theme';

export const Layout = styled.div`
  background-color: ${colors.white};
  display: grid;
  grid-column-gap: ${spacing.double};
  grid-template-columns: 2fr 1fr;
  margin: 0 -${spacing.layoutLRPadding};
  padding: ${spacing.double} ${spacing.layoutLRPadding} ${spacing.double};
`;

export const StyledDL = styled.dl`
    display: flex;
    flex-direction: column;
    gap: ${spacing.base};
`;

export const DataFeedList = styled.ul`
  list-style-type: disc;
  padding-left: ${spacing.plusQuarter};
`;

export const DataFeedName = styled.span`
  color: ${colors.textPrimary};
`;

export const DataFeedId = styled.span`
  color: ${colors.textSecondary};
`;

export const CampaignValue = styled.div`
  ${body2}
  & > * {
    display: block;
  }
`;
